// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ClientsService } from '@coa/app/core/services/clients.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureToggle } from '@coa/app/shared/feature-toggle/models/feature.toggle';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {

  constructor(
    private clientsService: ClientsService,
  ) {
  }

  isFeatureAdded(featureToggle: FeatureToggle, clientId: string): Observable<boolean> {
    return this.clientsService.getClients()
      .pipe(
        map((clientsResponse) => {
          return clientsResponse
            .content
            .find((client) => client.id.toString() === clientId.toString())
            ?.featureToggles
            ?.includes(featureToggle);
        }),
      );
  }

  getEnabledFeatures(clientId: string): Observable<FeatureToggle[]> {
    return this.clientsService.getClients()
      .pipe(
        map((clientsResponse) => {
          return clientsResponse
            .content
            .find((client) => client.id.toString() === clientId.toString())
            ?.featureToggles;
        }),
      );
  }
}
